import React from 'react';
import InvCard from './components/InvCard';
import { useLoaderData } from 'react-router-dom';
import { Row } from 'antd';





const Dashboard = () => {
  const overview = useLoaderData();

  return (
    <div>
      {overview.map((item, idx) => 
        <Row key={idx}>
          {item.items.map((obj, id) =>
            <InvCard key={id} item={obj}/>
          )}
        </Row>
      )}
    </div>
  )
}

export default Dashboard;